module.exports = __webpack_public_path__ + "static/media/data-science.dab30caf.svg";